// Jun 2026 (Randy) — in-app history of everything that has moved a creator's
// voucher credit. The in-app counterpart to the five transactional emails, so a
// refund, a hold or a release is still discoverable if the email was missed.
import { useEffect, useState } from "react";
import { ClockCounterClockwise, Lock } from "@phosphor-icons/react";
import { api } from "@/lib/api";

const fmt$ = (cents) => `$${((cents || 0) / 100).toFixed(2)}`;

const TONE = {
  grant: "#2F6B3A",
  refund: "#7A3A2A",
  freeze: "#8A5A00",
  unfreeze: "#2F6B3A",
  dispute_opened: "#8A5A00",
  dispute_won: "#2F6B3A",
  dispute_lost: "#7A3A2A",
  reversal: "#7A3A2A",
  flush: "#4A5D4E",
};

export default function VoucherActivityFeed({ limit = 12 }) {
  const [items, setItems] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get(`/me/voucher/activity?limit=${limit}`)
      .then((r) => { if (alive) setItems(r.data?.items || []); })
      .catch(() => { if (alive) setItems([]); });
    return () => { alive = false; };
  }, [limit]);

  if (!items || items.length === 0) return null;

  return (
    <div className="mt-4 pt-3 border-t hairline" data-testid="voucher-activity-feed">
      <div className="flex items-center gap-1.5 mb-2">
        <ClockCounterClockwise size={12} weight="duotone" className="text-[#6B6A68]" />
        <span className="text-[9px] uppercase tracking-[0.18em] text-[#6B6A68]">
          Credit activity
        </span>
      </div>
      <div className="space-y-1">
        {items.map((it) => (
          <div
            key={it.id}
            className="flex items-center gap-2 text-[10px]"
            data-testid={`voucher-activity-${it.event}`}
          >
            {it.held && <Lock size={10} weight="duotone" className="text-[#8A5A00] shrink-0" />}
            <span className="text-[#1C1B1A]">{it.label}</span>
            {it.provider && <span className="text-[#6B6A68]">· {it.provider}</span>}
            <span
              className="ml-auto font-mono tabular-nums shrink-0"
              style={{ color: TONE[it.event] || "#6B6A68" }}
            >
              {fmt$(it.amount_cents)}
            </span>
            <span className="text-[#A8A6A2] shrink-0 w-[74px] text-right">
              {new Date(it.at).toLocaleDateString(undefined, { month: "short", day: "numeric" })}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
